import { useEffect, useRef } from 'react';
import { useAppContainerContext } from './AppContainerContext';
import { ContentMeta } from './types';

export function useAppContainer() {
  const { siestaMode, setSiestaMode, siestaBusyGlowTop, setSiestaBusyGlowTop } =
    useAppContainerContext();

  return {
    siestaMode,
    setSiestaMode,
    siestaBusyGlowTop,
    setSiestaBusyGlowTop,
  };
}

export function useContentMeta(data: ContentMeta) {
  const { setContentMeta } = useAppContainerContext();
  const dataRef = useRef(data);
  dataRef.current = data;

  const metadataDocumentContent = data.metadata?.documentContent;

  useEffect(() => {
    const stableData: ContentMeta = {
      pageType: data.pageType,
      entityId: data.entityId,
      metadata: data.metadata,
      chatMode: data.chatMode,
      onChatStateChange: (...args) => dataRef.current.onChatStateChange?.(...args),
      getDocumentContent: () => dataRef.current.getDocumentContent?.() ?? '',
      chatActionsRef: data.chatActionsRef,
    };
    setContentMeta(stableData);
  }, [data.pageType, data.entityId, data.chatMode, metadataDocumentContent, setContentMeta]);

  useEffect(() => {
    return () => setContentMeta(null);
  }, [setContentMeta]);
}
